module.exports = __webpack_public_path__ + "static/media/drag-and-drop-order.e7ff8bb6.svg";